import{_ as t}from"./_baseGetTag-852b3600.js";import{i as o}from"./isObject-0b530d86.js";var r=function(r){if(!o(r))return!1;var e=t(r);return"[object Function]"==e||"[object GeneratorFunction]"==e||"[object AsyncFunction]"==e||"[object Proxy]"==e};export{r as i};
//# sourceMappingURL=isFunction-8a46d21f.js.map
